/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TermsAndConditionsQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type TermsAndConditionsQuery = {
  __typename?: 'Query',
  termsAndConditions?: {
    __typename?: 'TermsAndConditions',
    id: number,
    description?: string | null,
    deletedOn?: number | null,
    debtor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null
  } | null
};

export type AllTermsAndConditionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllTermsAndConditionsQuery = {
  __typename?: 'Query',
  allTermsAndConditions: Array<{
    __typename?: 'TermsAndConditions',
    id: number,
    description?: string | null,
    deletedOn?: number | null,
    debtor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null
  }>
};


export const TermsAndConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TermsAndConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"termsAndConditions"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"termsAndConditions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TermsAndConditions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedOn"}}]}}]} as unknown as DocumentNode<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>;
export const AllTermsAndConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllTermsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTermsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"termsAndConditions"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"termsAndConditions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TermsAndConditions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedOn"}}]}}]} as unknown as DocumentNode<AllTermsAndConditionsQuery, AllTermsAndConditionsQueryVariables>;